// extracted by mini-css-extract-plugin
module.exports = {"skills":"Skills_skills__3gfyo","column":"Skills_column__lvep7","divider":"Skills_divider__DsRNO"};